export default {
  parameters: {
    landing_id: "PlAbFreeTC",
  },
  newDesign: true,
  title: "Odbierz bezpłatne zajęcia w Kodland",
  downtimeUrl: "https://cl.kodland.tech",
  startPage: {
    startBackground: "white",
    quizBackground: "#white",
    title:
      "Zamiast grać w gry i oglądać YouTube'a, nasze dzieci uczą się programowania! 🔥",
    subtitle:
      "Zajęcia są prowadzone w języku polskim! Zapisz się teraz na bezpłatną lekcję ⬇️",
    image: {
      url: "/welcome/freetc_poland_desktop.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/freetc_poland_mob.png",
      style: {
        width: "100%",
      },
    },
    button: " Odbierz darmową lekcję ",
  },
  // successPage: {
  //   title: "¡Felicitaciones! 🎁",
  //   subtitle: "Haz clic en '📆 Reservar una clase' para completar el registro",
  //   button: "📆 Reservar una clase",
  // },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Dziękujemy za zaufanie naszej platformie edukacyjnej!",
    subtitle:
      "Niestety, tablety lub telefony nie nadają się do korzystania z naszych lekcji. Będziemy szczęśliwi, widząc Was na naszych zajęciach następnym razem!",
  },
  quizRotateBySteps: {
    1: {
      question: "Jak Twoje dziecko najczęściej spędza czas wolny?",
      answers: [
        "Na zajęciach artystycznych: rysowanie, muzyka, aktorstwo 🎨",
        "Gra w gry na telefonie lub na komputerze 🎮",
        "Gra w gry planszowe 😊",
        "Uprawia sport 🏃‍♂️",
        "Spędza czas z rodziną 👨‍👩‍👧",
        "Ogląda kreskówki 🦀",
        "Spędza czas z przyjaciółmi 💬"
      ],
    },
    2: {
      question: "Dlaczego warto zainteresować się nauką programowania?",
      answers: [
        "Dziecko gra w dużo gier 🎮",
        "Dziecko jest 'uzależnione' od YouTube'a i TikTok'a 😜",
        "Dziecko interesuje się programowaniem 👾",
        "Inne ❓",
      ],
    },
    3: {
      title: "Ile lat ma twoje dziecko? Zwracamy uwagę, że dziecko powinno posiadać umiejętność płynnego czytania, aby być w stanie w pełni uczestniczyć w lekcji",
      type: "age",
      button: "",
    },
    4: {
      question:
        "Czy masz komputer/laptop?",
      answers: [
        "Tak ✔️",
        {
          answer: "Nie ❌",
          stopAnswer: true,
        },
      ],
    },
    5: {
      title: "Gratulacje!",
      typeInfo: "congrats",
      subtitle:
        "Kliknij '📅 Zarezerwuj zajęcia', aby dokończyć rejestrację.",
      button: "📅 Zarezerwuj zajęcia",
    },
    6: {
      title: "Zarezerwuj zajęcia",
      type: "one-page-contacts",
      subtitle: "",
      button: "👏 Świetnie. Ostatni krok!",
    },
    7: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    8: {
      title:
        "Przejrzyj te informacje, aby zakończyć rejestrację ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Pamiętaj, że do lekcji będziesz potrzebować działającego komputera stacjonarnego lub laptopa i musisz towarzyszyć swojemu dziecku przez cały czas trwania zajęć. Pamiętaj, że zajęcia są indywidualne i spersonalizowane.",
      button: "Co jeszcze?",
    },
    9: {
      title: "Przed zajęciami próbnymi sprawdź swoją skrzynkę e-mail i WhatsApp 📞",
      typeInfo: "whatsapp",
      subtitle:
        "Na 24 godziny przed zajęciami wyślemy przypomnienie, a na 2 godziny przed zajęciami poprosimy o potwierdzenie obecności. Bardzo ważne jest, abyśmy pozostali w kontakcie, aby zajęcia nie zostały odwołane.",
      button: "Co jeszcze?",
    },
    10: {
      title: "Lekcja odbędzie się na naszej platformie 💻",
      typeInfo: "classroom",
      subtitle:
        "Otrzymasz link i unikalny kod przez WhatsApp oraz e-mail. Wystarczy kliknąć w link, a przeniesie Cię on prosto do lekcji. Bez dodatkowych aplikacji, bez pobierania.",
      button: "Rozumiem ✅",
    }
  },
};
